module.exports = __webpack_public_path__ + "img/menu-background-left.c9a80afc.jpg";